module.exports = __webpack_public_path__ + "static/media/emptyImageFeatureDetails.f195d594.png";